import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import getSectionMenuPricesCount from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/SectionMenu/functions/getSectionMenuPricesCount'

/**
 * Показывать ли пункт «Цены» в SectionMenu.
 */
export default function isSectionMenuPricesItemVisible(
  lpu: Lpu,
  synonymPricesCount: number | undefined,
): boolean {
  const pricesCount = getSectionMenuPricesCount(lpu, synonymPricesCount)

  return !lpu.is_not_index_by_price_count
    && !lpu.closed
    && pricesCount > 0
}
